export const translation = {
  common: {
    logout: 'Одјава',
    account: 'Налог',
    myAccount: 'Мој налог',
    search: 'Претражи...',
    actions: 'Акције',
    view: 'Прегледај',
    edit: 'Измени',
    delete: 'Обриши',
    save: 'Сачувај',
    saving: 'Чување...',
    deleting: 'Брисање...',
    cancel: 'Одустани',
    close: 'Затвори',
    back: 'Назад',
    backToList: 'Назад на листу',
    backToVehicles: 'Назад на возила',
    new: 'Ново',
    create: 'Креирај',
    list: 'Листа',
    none: 'Ниједно',
    all: 'Све',
    noResults: 'Нема резултата',
    rowsPerPage: 'Редова по страници:',
    viewVehicle: 'Погледај возило',
    loading: 'Учитавање...',
    error: 'Грешка',
    success: 'Успјешно',
    required: 'Обавезно поље',
    activeContracts: 'Активни уговори',
    viewAll: 'Прегледај све',
    errorLoadingData: 'Грешка при учитавању података',
    unlimited: 'Неограничено',
    validation: {
      // Required fields
      required: 'Ово поље је обавезно',

      // String validation
      minLength: 'Минимална дужина је {{min}} карактера',
      maxLength: 'Максимална дужина је {{max}} карактера',
      exactLength: 'Дужина мора бити тачно {{length}} карактера',

      // Number validation
      min: 'Минимална вредност је {{min}}',
      max: 'Максимална вредност је {{max}}',
      positive: 'Вредност мора бити позитиван број',
      nonNegative: 'Вредност не може бити негативна',
      integer: 'Вредност мора бити цео број',

      // Format validation
      invalidEmail: 'Неважећа email адреса',
      invalidPhone: 'Неважећи број телефона',
      invalidUrl: 'Неважећи URL',
      invalidDate: 'Неважећи датум',

      // Date validation
      dateInPast: 'Датум мора бити у прошлости',
      dateInFuture: 'Датум мора бити у будућности',
      dateTodayOrFuture: 'Датум мора бити данас или у будућности',
      dateAfter: 'Датум мора бити после {{date}}',
      dateBefore: 'Датум мора бити пре {{date}}',
      endDateAfterStartDate: 'Датум завршетка мора бити после датума почетка',

      // Custom validations
      duplicate: 'Ова вредност већ постоји',
      notFound: 'Вредност није пронађена',
      invalidFormat: 'Неважећи формат',

      // General
      invalidValue: 'Неважећа вредност',
    },
    errors: {
      // General errors
      saveFailed: 'Грешка при чувању података',
      loadFailed: 'Грешка при учитавању података',
      deleteFailed: 'Грешка при брисању',
      unauthorized: 'Немате дозволу за ову акцију',
      networkError: 'Грешка у мрежи. Проверите интернет конекцију',
      unknownError: 'Дошло је до непознате грешке',
      validationErrors: 'Молимо исправите следеће грешке:',
    },
  },
  language: {
    latin: 'Латиница',
    cyrillic: 'Ћирилица',
  },
  roles: {
    systemAdmin: 'Систем Администратор',
    companyAdmin: 'Директор',
    fleetManager: 'Менаџер',
    fleetUser: 'Корисник',
    contractManager: 'Менаџер уговора',
    userAdmin: 'Администратор корисника',
  },
  nav: {
    dashboard: 'Контролна табла',
  },
  modules: {
    fleet: {
      name: 'Возни парк',
    },
    users: {
      name: 'Корисници',
    },
  },
  fleets: {
    dashboard: {
      subtitle: 'Преглед возног парка',
    },
    nav: {
      vehicles: 'Возила',
      allVehicles: 'Сва возила',
      requests: 'Захтјеви',
      operations: 'Операције',
      services: 'Сервиси',
      fuel: 'Гориво',
      tires: 'Гуме',
      registrations: 'Регистрације',
      contracts: 'Уговори',
      activeContracts: 'Активни уговори',
      providers: 'Добављачи',
      travelOrders: 'Вожње',
      travelOrderPeriods: 'Путни налози',
      fleetUsers: 'Корисници',
      myAccount: 'Мој налог',
      reports: 'Извјештаји',
      tireTracking: 'Евиденција гума',
    },
    vehicles: {
      title: 'Возила',
      subtitle: 'Једноставан увид у детаље возила',
      add: 'Додај возило',
      addVehicle: 'Додај ново возило',
      editVehicle: 'Измени возило',
      notFound: 'Возило није пронађено',
      basicInfoButton: 'Подаци',
      registration: 'Регистарска ознака',
      assignedTo: 'Задужио',
      brand: 'Марка',
      model: 'Модел',
      type: 'Тип',
      year: 'Година',
      status: 'Статус',
      requestPriority: 'Приоритет',
      color: 'Боја',
      chassisNumber: 'Број шасије',
      engineNumber: 'Број мотора',
      enginePower: 'Снага мотора',
      fuelType: 'Тип горива',
      mileage: 'Километража',
      registrationNumber: 'Број саобраћајне',
      registrationDate: 'Датум регистрације',
      registrationExpiry: 'Истек регистрације',
      generalInfo: 'Општи подаци',
      registrationInfo: 'Регистрација',
      vehicleIsRegistered: 'Возило је регистровано',
      technicalInfo: 'Технички подаци',
      serviceHistory: 'Историја сервиса',
      fuelLogs: 'Евиденција горива',
      noServiceHistory: 'Нема историје сервиса',
      noFuelLogs: 'Нема евиденције горива',
      noDocuments: 'Нема докумената',
      tabs: {
        basicInfo: 'Основни подаци',
        services: 'Сервиси',
        registrations: 'Регистрације',
        fuel: 'Гориво',
        assigmnets: 'Доделe',
      },
      // Form field labels (matching English property names)
      fields: {
        plateNumber: 'Регистарска ознака',
        brand: 'Марка',
        model: 'Модел',
        vehicleType: 'Тип возила',
        productionDate: 'Датум производње',
        chassisNumber: 'Број шасије',
        registrationNumber: 'Број саобраћајне',
        registrationDate: 'Датум регистрације',
        registrationExpiry: 'Истек регистрације',
        wheelDimension: 'Димензија точка',
        odometer: 'Километража',
        engineNumber: 'Број мотора',
        powerKW: 'Снага мотора (kW)',
        capacityCM3: 'Запремина (cm³)',
        fuelType: 'Тип горива',
        color: 'Боја',
        passengerSeats: 'Број седишта',
        fuelCardNumber: 'Број картице за гориво',
        currentDriverId: 'Запослени',
        requestPriority: 'Приоритет захтева',
      },
      vehicleTypes: {
        Passenger: 'Путнички',
        Cargo: 'Теретни',
        Special: 'Специјални',
        Work: 'Радни',
        Trailer: 'Прикључно',
      },
      availability: {
        title: 'Доступност возила',
        errorLoading: 'Грешка при учитавању података о доступности',
        free: 'Слободно',
        hoursOf24: '{{hours}}h од 24h ({{percent}}%)',
        eventTypes: {
          travelOrder: 'Заузето',
          service: 'Сервис',
          outOfService: 'Ван функције',
          manual: 'Резервација',
          unavailable: 'Недоступно',
        },
      },
    },
    services: {
      title: 'Сервиси',
      subtitle: 'Преглед и управљање сервисима возила',
      add: 'Нови сервис',
      create: 'Нови сервис',
      edit: 'Измени сервис',
      pending: 'на чекању',
      loading: 'Учитавање сервиса...',
      notFound: 'Сервис није пронађен или је дошло до грешке при учитавању.',
      errorLoading: 'Грешка при учитавању сервиса. Покушајте поново.',
      notSpecified: 'Није наведено',
      viewVehicle: 'Погледај возило',

      // Table columns
      vehicle: 'Возило',
      type: 'Тип',
      description: 'Опис',
      scheduledDate: 'Датум',
      provider: 'Сервисер',
      cost: 'Трошак',
      status: 'Статус',

      // Form sections
      form: {
        basicInfo: 'Основни подаци',
        providerSection: 'Добављач / Сервисер',
        invoiceSection: 'Фактура и напомене',
        itemsSection: 'Ставке сервиса',
        notesSection: 'Напомене',
        newService: 'Нови сервис',
        editService: 'Измени сервис',
      },

      // Fields
      fields: {
        vehicle: 'Возило',
        odometerReading: 'Стање километраже',
        description: 'Опис сервиса',
        descriptionPlaceholder: 'Нпр. Редован сервис 30.000 км - замена уља и филтера',
        provider: 'Добављач',
        providerNotSelected: 'Није одабрано',
        providerNone: 'Није одабрано',
        contract: 'Уговор',
        customProviderName: 'Назив сервисера (ручни унос)',
        invoiceNumber: 'Број фактуре',
        notes: 'Напомене',
        notesPlaceholder: 'Додатне напомене о сервису...',
      },

      // Detail page
      detail: {
        basicInfo: 'Основни подаци',
        vehicle: 'Возило',
        odometer: 'Километража',
        createdAt: 'Датум креирања',
        updatedAt: 'Датум измене',
        invoiceNumber: 'Број фактуре',
        provider: 'Добављач',
        totalCost: 'Укупан трошак',
        notes: 'Напомене',
        items: 'Ставке сервиса',
        itemCount: 'ставка',
        itemsCount: 'ставки',
      },

      // Service items
      items: {
        title: 'Ставке сервиса',
        add: 'Додај ставку',
        addButton: 'Додај',
        edit: 'Измени ставку',
        editTooltip: 'Измени',
        delete: 'Обриши ставку',
        deleteTooltip: 'Обриши',
        noItems: 'Нема ставки',
        noItemsHint: 'Кликните "Додај ставку" да додате прву ставку сервиса',
        noItemsHintMobile: 'Кликните "Додај" да додате прву ставку сервиса',
        noItemsDetail: 'Овај сервис нема додатих ставки',
        total: 'Укупно',
        totalLabel: 'УКУПНО:',

        // Table columns
        type: 'Тип',
        description: 'Опис',
        quantity: 'Кол.',
        quantityFull: 'Количина',
        unitPrice: 'Цена',
        unitPriceFull: 'Цена по јединици',
        totalPrice: 'Укупно',
        actions: 'Акције',

        // Item types
        types: {
          Other: 'Остало',
          Work: 'Рад',
          Part: 'Део',
          Tire: 'Гума',
          Fee: 'Накнада',
        },
      },

      // Add/Edit item dialog
      itemDialog: {
        addTitle: 'Додај ставку',
        editTitle: 'Измени ставку',
        itemType: 'Тип ставке',
        description: 'Опис',
        descriptionPlaceholder: 'Нпр. Замена уља и филтера',
        quantity: 'Количина',
        unitPrice: 'Цена по јединици',
        unitPriceHint: 'Са ПДВ-ом (бруто)',
        tireDetails: 'Детаљи гуме',
        tireType: 'Тип гуме',
        tireAction: 'Акција',
        tireSize: 'Димензија',
        tireSizePlaceholder: '205/55R16',
        tireDiameter: 'Пречник (фелне)',
        tireDotCode: 'DOT код (опционо)',
        tireDotCodePlaceholder: '2423',
        tireDotCodeHint: 'Седмица и година производње (нпр. 2423 = 24. седмица 2023)',
        save: 'Сачувај измене',
        add: 'Додај',
        cancel: 'Откажи',
        validationError: 'Молимо исправите следеће грешке:',

        // Validation messages
        fieldRequired: 'Ово поље је обавезно',
        quantityMustBePositive: 'Количина мора бити већа од 0',
        priceMustBeNonNegative: 'Цена мора бити 0 или већа',
      },

      // Tire types
      tireTypes: {
        Summer: 'Летња',
        Winter: 'Зимска',
        AllSeason: 'Целогодишња',
      },

      // Tire actions
      tireActions: {
        Other: 'Остало',
        GroupAction: 'Групна акција',
        Purchase: 'Куповина',
        Replace: 'Замена',
        Storage: 'Складиштење',
        Dispose: 'Отпис',
      },

      // Actions
      actions: {
        viewVehicle: 'Погледај возило',
        edit: 'Измени',
        delete: 'Обриши',
        save: 'Сачувај',
        saving: 'Чување...',
        cancel: 'Откажи',
      },

      // Validation
      validation: {
        vehicleRequired: 'Возило је обавезно',
        odometerRequired: 'Стање километраже је обавезно',
        odometerPositive: 'Стање километраже мора бити позитиван број',
        odometerCannotDecrease: 'Стање километраже не може бити мање од тренутног стања возила ({{current}} км). Унели сте: {{provided}} км',
        descriptionRequired: 'Опис је обавезан',
        descriptionMinLength: 'Опис мора имати најмање 10 карактера',
        itemTypeRequired: 'Тип ставке је обавезан',
        itemDescriptionRequired: 'Опис ставке је обавезан',
        quantityRequired: 'Количина је обавезна',
        quantityPositive: 'Количина мора бити позитиван број',
        unitPriceRequired: 'Цена је обавезна',
        unitPricePositive: 'Цена мора бити позитиван број',
        tireSizeRequired: 'Димензија гуме је обавезна',
        tireDiameterRequired: 'Пречник гуме је обавезан',
        invoiceNumberRequired: 'Број фактуре је обавезан',
        contractRequired: 'Уговор је обавезан када је одабран добављач',
        customProviderNameRequired: 'Назив сервисера је обавезан када добављач није одабран',
        itemsRequired: 'Бар једна ставка је обавезна',
      },

      // Helper texts
      helpers: {
        currentOdometer: 'Тренутно стање: {{odometer}} км',
      },

      // Success messages
      success: {
        created: 'Сервис је успјешно креиран',
        updated: 'Сервис је успјешно ажуриран',
        deleted: 'Сервис је успјешно обрисан',
        itemAdded: 'Ставка је успјешно додата',
        itemUpdated: 'Ставка је успјешно ажурирана',
        itemDeleted: 'Ставка је успјешно обрисана',
      },

      // Error messages
      errors: {
        createFailed: 'Грешка при креирању сервиса',
        updateFailed: 'Грешка при ажурирању сервиса',
        deleteFailed: 'Грешка при брисању сервиса',
        loadFailed: 'Грешка при учитавању сервиса',
        itemAddFailed: 'Грешка при додавању ставке',
        itemUpdateFailed: 'Грешка при ажурирању ставке',
        itemDeleteFailed: 'Грешка при брисању ставке',
      },

      // Dialogs
      deleteConfirmTitle: 'Обриши сервис',
      deleteConfirmMessage: 'Да ли сте сигурни да желите да обришете овај сервис? Ова акција се не може поништити.',
      deleteItemTitle: 'Обриши ставку',
      deleteItemMessage: 'Да ли сте сигурни да желите да обришете ову ставку?',
    },
    providers: {
      title: 'Добављачи',
      subtitle: 'Преглед добављача за возни парк',
      create: 'Нови добављач',
      edit: 'Измени добављача',
      notFound: 'Добављач није пронађен',
      viewAllServiceTypes: 'Прикажи све типове услуга',
      search: 'Претражи добављаче...',
      noResults: 'Нема добављача који одговарају претрази',
      empty: 'Нема добављача',
      fields: {
        name: 'Назив',
        serviceTypes: 'Типови услуга',
        contactEmail: 'Емаил',
        contactPhone: 'Телефон',
        address: 'Адреса',
        taxId: 'ПИБ',
        notes: 'Напомене',
        activeContracts: 'Активни уговори',
      },
      serviceTypes: {
        Service: 'Сервис',
        Repair: 'Поправка',
        Tire: 'Гуме',
        Fuel: 'Гориво',
        Registration: 'Регистрација',
        TechnicalInspection: 'Технички преглед',
        Insurance: 'Осигурање',
        Cleaning: 'Чишћење',
        Other: 'Остало',
      },
      details: {
        info: 'Информације о добављачу',
        contracts: 'Уговори',
        noContracts: 'Нема уговора',
      },
    },
    contracts: {
      title: 'Уговори',
      subtitle: 'Преглед уговора везаних за возни парк',
      create: 'Нови уговор',
      edit: 'Измени уговор',
      notFound: 'Уговор није пронађен',
      search: 'Претражи уговоре...',
      noResults: 'Нема уговора који одговарају претрази',
      empty: 'Нема уговора',
      add: 'Нови уговор',
      number: 'Број уговора',
      type: 'Тип',
      supplier: 'Добављач',
      vehicle: 'Возило',
      startDate: 'Почетак',
      endDate: 'Истек',
      value: 'Вриједност',
      status: 'Статус',
      expiringWarning: '{{count}} уговор(а) истиче ускоро',
      expiredWarning: '{{count}} уговор(а) је истекло',
      viewProvider: 'Погледај добављача',
      viewAllScopes: 'Прикажи све обухвате',
      fields: {
        providerId: 'Добављач',
        provider: 'Добављач',
        contractNumber: 'Број уговора',
        scopes: 'Обухват',
        validFrom: 'Важећи од',
        validTo: 'Важећи до',
        contractAmountNet: 'Износ уговора (без ПДВ-а)',
        contractAmountNetShort: 'Износ (НЕТ)',
        vatRate: 'Стопа ПДВ-а',
        contractAmountGross: 'Износ уговора (са ПДВ-ом)',
        contractAmountGrossShort: 'Износ (БРУТО)',
        remainingAmountGrossShort: 'Преостало (БРУТО)',
        contractAmountHint: 'Унесите износ уговора са ПДВ-ом',
        consumedAmountNet: 'Потрошено (НЕТ)',
        consumedAmountGross: 'Потрошено (БРУТО)',
        remainingAmountNet: 'Преостало (НЕТ)',
        remainingAmountGross: 'Преостало (БРУТО)',
        status: 'Статус',
        notes: 'Напомене',
      },
      details: {
        info: 'Информације о уговору',
      },
      scopes: {
        Service: 'Сервис',
        Repair: 'Поправка',
        Tire: 'Гуме',
        Fuel: 'Гориво',
        Registration: 'Регистрација',
        TechnicalInspection: 'Технички преглед',
        Insurance: 'Осигурање',
        Cleaning: 'Чишћење',
        Other: 'Остало',
      },
      statuses: {
        Draft: 'Нацрт',
        Active: 'Активан',
        Expired: 'Истекао',
        Terminated: 'Раскинут',
      },
      expiringSoon: 'Истиче ускоро',
    },
    tireProcurement: {
      title: 'Набавка гума',
      subtitle: 'Преглед набавки гума за возни парк',
      add: 'Нова набавка',
      inProgress: 'у току',
      activeCount: '{{count}} активна набавка(е) у току',
      number: 'Број набавке',
      vehicle: 'Возило',
      type: 'Тип гуме',
      size: 'Димензија',
      quantity: 'Количина',
      supplier: 'Добављач',
      date: 'Датум',
      price: 'Цијена',
      status: 'Статус',
    },
    travelOrders: {
      title: 'Вожње',
      fields: {
        orderNumber: 'Број вожње',
        vehiclePlateNumber: 'Регистарска ознака',
        purpose: 'Сврха',
        destination: 'Дестинација',
        plannedStartDate: 'Планирани почетак',
        plannedEndDate: 'Планирани завршетак',
        status: 'Статус',
      },
      adjustOdometer: {
        button: 'Корекција километраже',
        title: 'Корекција километраже вожње',
        info: 'Ручна корекција стања километраже за завршену или затворену вожњу. Вриједност на возилу се не мијења аутоматски.',
        currentStart: 'Тренутна почетна: {{value}} km',
        currentEnd: 'Тренутна завршна: {{value}} km',
        newStartLabel: 'Нова почетна километража',
        newEndLabel: 'Нова завршна километража',
        reasonLabel: 'Разлог корекције',
        reasonHelper: 'Обавезно: Унесите разлог за корекцију километраже',
        submit: 'Сачувај корекцију',
        submitting: 'Спремање...',
        cancel: 'Одустани',
        validation: {
          atLeastOneRequired: 'Унесите нову почетну или завршну километражу',
          negative: 'Километража не може бити негативна',
          endLessThanStart: 'Завршна километража не може бити мања од почетне',
          unchanged: 'Нове вриједности су исте као тренутне',
          reasonRequired: 'Разлог корекције је обавезан',
          reasonTooLong: 'Разлог не може бити дужи од 500 карактера',
        },
      },
    },
    travelOrderPeriods: {
      adjustOdometer: {
        button: 'Корекција километраже',
        title: 'Корекција километраже периода',
        info: 'Ручна корекција почетне и/или завршне километраже затвореног периода. Вриједност на возилу и сусједним периодима се не мијења аутоматски.',
        currentStart: 'Тренутна почетна: {{value}} km',
        currentEnd: 'Тренутна завршна: {{value}} km',
        newStartLabel: 'Нова почетна километража',
        newEndLabel: 'Нова завршна километража',
        optionalHelper: 'Опционално — попуните само поље које коригујете',
        reasonLabel: 'Разлог корекције',
        reasonHelper: 'Обавезно: Унесите разлог за корекцију километраже',
        submit: 'Сачувај корекцију',
        submitting: 'Спремање...',
        cancel: 'Одустани',
        chain: {
          title: 'Упозорење о доследности периода',
          previousMismatch: 'Завршна километража претходног периода ({{prev}} km) се не поклапа са почетном овог периода ({{current}} km).',
          nextMismatch: 'Завршна километража овог периода ({{current}} km) се не поклапа са почетном сљедећег периода ({{next}} km).',
        },
        validation: {
          required: 'Унесите исправну вриједност',
          negative: 'Километража не може бити негативна',
          lessThanStart: 'Завршна километража не може бити мања од почетне ({{start}} km)',
          endLessThanStart: 'Завршна километража не може бити мања од почетне ({{start}} km)',
          unchanged: 'Нова вриједност је иста као тренутна',
          atLeastOne: 'Морате унијети барем једну вриједност: почетну или завршну километражу',
          reasonRequired: 'Разлог корекције је обавезан',
          reasonTooLong: 'Разлог не може бити дужи од 500 карактера',
        },
      },
    },
    trips: {
      title: 'Вожње',
    },
    reports: {
      title: 'Извјештаји',
    },
    requests: {
      title: 'Захтјеви за измјене',
      subtitle: 'Преглед и одобравање захтјева за измјене возила',
      pendingCount: '{{count}} захтјев(а) чека одобрење',
      noRequests: 'Нема захтјева',
      vehicle: 'Возило',
      type: 'Тип',
      field: 'Поље',
      oldValue: 'Стара вриједност',
      newValue: 'Нова вриједност',
      submittedBy: 'Подносилац',
      date: 'Датум',
      status: 'Статус',
      approve: 'Одобри',
      reject: 'Одбиј',
    },
    vehicleRequests: {
      title: 'Захтјеви за возила',
      subtitle: 'Преглед и управљање захтјевима за коришћење возила',
      create: 'Нови захтјев',
      add: 'Нови захтјев',
      details: 'Детаљи захтјева',
      loading: 'Учитавање захтјева...',
      notFound: 'Захтјев није пронађен или је дошло до грешке при учитавању.',

      // Tabs
      tabs: {
        all: 'Сви захтјеви',
        my: 'Моји захтјеви',
        pending: 'На чекању',
      },

      // Table columns
      columns: {
        vehicle: 'Возило',
        purpose: 'Сврха',
        period: 'Период',
        requester: 'Подносилац',
        status: 'Статус',
        actions: 'Акције',
      },

      // Registration warnings (informative only - do not block approval)
      registrationWarning: {
        missing: 'Возило нема евидентирану регистрацију. Провјерите документацију прије одобрења.',
        startsLate:
          'Регистрација возила важи тек од {{validFrom}}, а захтјев почиње раније. Провјерите документацију прије одобрења.',
        expiresEarly:
          'Регистрација возила истиче {{validTo}}, прије краја траженог периода. Провјерите документацију прије одобрења.',
      },

      // Form
      form: {
        title: 'Нови захтјев за возило',
        subtitle: 'Попуните форму да бисте затражили возило за одређену сврху',
        vehicleSelection: 'Одабир возила',
        purposeSection: 'Сврха захтјева',
        periodSection: 'Период и дестинација',
        additionalInfo: 'Додатне информације',
        preselectedVehicle: 'Возило је већ одабрано:',
        selectVehicle: 'Одаберите возило',
        purposeHint: 'Опишите сврху коришћења возила (минимум 10 карактера)',
        purposePlaceholder: 'Нпр. Службено путовање у Београд - састанак са клијентом',
        destinationPlaceholder: 'Нпр. Београд, Србија',
        estimatedDistancePlaceholder: 'Нпр. 250',
        notesPlaceholder: 'Додатне напомене или захтеви...',
        submit: 'Пошаљи захтјев',
        submitting: 'Слање...',
      },

      // Fields
      fields: {
        vehicle: 'Возило',
        vehiclePlateNumber: 'Регистарска ознака',
        vehicleDescription: 'Опис возила',
        requester: 'Подносилац захтјева',
        purpose: 'Сврха',
        destination: 'Дестинација',
        estimatedDistance: 'Процењена дистанца',
        requestedStartDate: 'Датум почетка',
        requestedEndDate: 'Датум завршетка',
        startDate: 'Датум почетка',
        endDate: 'Датум завршетка',
        duration: 'Трајање',
        notes: 'Напомене',
        status: 'Статус',
        approver: 'Одобрио',
        approvalDate: 'Датум одобрења',
        rejectionDate: 'Датум одбијања',
        rejectionReason: 'Разлог одбијања',
        cancellationDate: 'Датум отказивања',
        cancellationReason: 'Разлог отказивања',
        createdAt: 'Креирано',
        travelOrder: 'Вожња',
      },

      // Statuses
      statuses: {
        pending: 'На чекању',
        approved: 'Одобрен',
        rejected: 'Одбијен',
        cancelled: 'Отказан',
        completed: 'Завршен',
      },

      // Sections
      sections: {
        summary: 'Преглед захтјева',
        details: 'Детаљи захтјева',
        decision: 'Информације о одлуци',
        timeline: 'Временска линија',
      },

      // Actions
      actions: {
        approve: 'Одобри',
        reject: 'Одбиј',
        cancel: 'Откажи',
        view: 'Прегледај',
        viewVehicle: 'Погледај возило',
        back: 'Назад',
      },

      // Dialogs
      dialogs: {
        approveTitle: 'Одобри захтјев за возило',
        approveMessage: 'Да ли сте сигурни да желите да одобрите овај захтјев?',
        approveDetails: 'Детаљи захтјева:',
        approveConfirm: 'Одобри захтјев',
        approveConfirming: 'Одобравање...',
        approveSuccess: 'Захтјев је успјешно одобрен',

        rejectTitle: 'Одбиј захтјев за возило',
        rejectMessage: 'Молимо унесите разлог одбијања захтјева.',
        rejectDetails: 'Детаљи захтјева:',
        rejectReason: 'Разлог одбијања',
        rejectReasonPlaceholder: 'Нпр. Возило је већ резервисано за тај период...',
        rejectReasonHint: 'Минимално 10 карактера',
        rejectConfirm: 'Одбиј захтјев',
        rejectConfirming: 'Одбијање...',
        rejectSuccess: 'Захтјев је успјешно одбијен',

        cancelTitle: 'Откажи захтјев за возило',
        cancelMessage: 'Молимо унесите разлог отказивања захтјева.',
        cancelDetails: 'Детаљи захтјева:',
        cancelReason: 'Разлог отказивања',
        cancelReasonPlaceholder: 'Нпр. Путовање је отказано због промена планова...',
        cancelReasonHint: 'Минимално 10 карактера',
        cancelConfirm: 'Откажи захтјев',
        cancelConfirming: 'Отказивање...',
        cancelSuccess: 'Захтјев је успјешно отказан',
        cancelDisabledTooltip: 'Одобрени захтјеви не могу бити отказани. Молимо откажите вожњу уместо тога.',
      },

      // Messages
      messages: {
        period: 'Период',
        days: 'дана',
        day: 'дан',
        km: 'км',
        travelOrderCreated: 'Вожња је креирана за овај захтјев. ID: {{id}}',
      },

      // Validation
      validation: {
        vehicleRequired: 'Возило је обавезно',
        purposeRequired: 'Сврха је обавезна',
        purposeMinLength: 'Сврха мора имати најмање 10 карактера',
        startDateRequired: 'Датум почетка је обавезан',
        endDateRequired: 'Датум завршетка је обавезан',
        startDateTodayOrFuture: 'Датум почетка мора бити данас или у будућности',
        endDateAfterStartDate: 'Датум завршетка мора бити после датума почетка',
        estimatedDistancePositive: 'Процењена километража мора бити позитиван број',
        reasonRequired: 'Разлог је обавезан',
        reasonMinLength: 'Разлог мора имати најмање 10 карактера',
      },
    },
    registrations: {
      title: 'Регистрације',
      subtitle: 'Преглед и управљање регистрацијама возила',
      create: 'Нова регистрација',
      createRegistration: 'Нова регистрација',
      editRegistration: 'Измени регистрацију',
      noRegistrations: 'Нема регистрација',
      notFound: 'Регистрација није пронађена',
      loading: 'Учитавање регистрације...',
      costPending: 'Без трошкова',
      costPendingHint: 'Регистрација је унета без износа и фактуре — допунити кроз Измену.',
      generalInfo: 'Општи подаци',
      costInfo: 'Подаци о трошковима',
      providerInfo: 'Информације о провајдеру',
      additionalInfo: 'Додатне информације',
      fields: {
        vehicle: 'Возило',
        validFrom: 'Важи од',
        validTo: 'Важи до',
        registrationDate: 'Датум регистрације',
        registrationExpiry: 'Истек регистрације',
        registrationNumber: 'Број саобраћајне',
        odometerReading: 'Километража',
        cost: 'Трошак',
        invoiceNumber: 'Број фактуре',
        provider: 'Провајдер',
        contract: 'Уговор',
        customProviderName: 'Назив провајдера',
        description: 'Опис',
        notes: 'Напомене',
        updateVehicleRegistration: 'Ажурирај регистрацију возила',
      },
      notesPlaceholder: 'Опционе напомене...',
      columns: {
        vehiclePlate: 'Регистарска ознака',
        validFrom: 'Важи од',
        expiryDate: 'Датум истека',
        cost: 'Трошак',
        provider: 'Добављач',
        status: 'Статус',
      },
      filters: {
        vehicle: 'Возило',
        provider: 'Добављач',
        status: 'Статус',
        dateFrom: 'Датум од',
        dateTo: 'Датум до',
      },
      details: {
        basicInfo: 'Основни подаци',
        vehicleDetails: 'Детали возила',
        providerInfo: 'Информације о добављачу/уговору',
        costDetails: 'Детали трошкова',
        notes: 'Напомене',
        vehiclePlate: 'Регистарска ознака',
        validFrom: 'Важи од',
        validTo: 'Важи до',
        registrationDate: 'Датум регистрације',
        expiryDate: 'Датум истека',
        status: 'Статус',
        description: 'Опис',
        odometerReading: 'Километража',
        registrationNumber: 'Број саобраћајне',
        vehicleId: 'ID возила',
        providerName: 'Назив добављача',
        providerId: 'ID добављача',
        totalCost: 'Укупан трошак',
        invoiceNumber: 'Број фактуре',
      },
      deleteConfirmTitle: 'Потврда брисања регистрације',
      deleteConfirmMessage: 'Да ли сте сигурни да желите да обришете регистрацију: {{registrationInfo}}?',

      deleteSuccess: 'Регистрација је успјешно обрисана',
      deleteError: 'Грешка при брисању регистрације',

      // Status labels
      status: {
        Valid: 'Важећа',
        ExpiringSoon: 'Истиче ускоро',
        Expired: 'Истекла',
        Unknown: 'Непознато',
      },

      // Actions
      actions: {
        view: 'Прегледај',
        edit: 'Измени',
        delete: 'Обриши',
        create: 'Креирај',
      },

      validation: {
        vehicleRequired: 'Возило је обавезно',
        validFromRequired: 'Датум почетка важења је обавезан',
        validToRequired: 'Датум истека важења је обавезан',
        odometerRequired: 'Километража је обавезна',
        odometerNonNegative: 'Километража не може бити негативна',
        costRequired: 'Трошак је обавезан',
        costNonNegative: 'Трошак не може бити негативан',
        descriptionRequired: 'Опис је обавезан',
        invoiceNumberRequired: 'Број фактуре је обавезан',
        contractRequired: 'Уговор је обавезан када је одабран добављач',
        customProviderNameRequired: 'Назив добављача је обавезан када добављач није одабран',
      },

      // Success messages
      success: {
        created: 'Регистрација је успјешно креирана',
        updated: 'Регистрација је успјешно ажурирана',
        deleted: 'Регистрација је успјешно обрисана',
      },

      // Error messages
      errors: {
        createFailed: 'Грешка при креирању регистрације',
        updateFailed: 'Грешка при ажурирању регистрације',
        deleteFailed: 'Грешка при брисању регистрације',
        loadFailed: 'Грешка при учитавању регистрације',
      },
    },
    fuelLogs: {
      title: 'Евиденција горива',
      add: 'Додај унос горива',
      edit: 'Измени унос горива',
      withoutTravelOrder: 'Без вожње',
      viewTrip: 'Погледај вожњу',
      viewTravelOrder: 'Погледај путни налог',
      sectionTrip: 'Вожња',
      sectionTravelOrder: 'Путни налог',
      tripNumber: 'Број вожње',
      travelOrderNumber: 'Број путног налога',
      list: {
        title: 'Гориво',
        subtitle: 'Преглед свих уноса горива',
        searchPlaceholder: 'Претражи по возилу, станици, путном налогу...',
        allTypes: 'Сви типови',
        emptyMessage: 'Нема унетих података о гориву.',
        errorMessage: 'Грешка при учитавању података о гориву.',
      },
      table: {
        vehicle: 'Возило',
        travelOrder: 'Путни налог',
        odometer: 'Километража',
        pricePerLiter: 'Цена/L',
        total: 'Укупно',
        station: 'Станица',
        noOrder: 'Без налога',
      },
      delete: {
        title: 'Потврда брисања',
        message: 'Да ли сте сигурни да желите да обришете унос горива: {{info}}?',
      },
      fuelTypes: {
        Other: 'Остало',
        Diesel: 'Дизел',
        Petrol: 'Бензин',
        LPG: 'ТНГ',
        CNG: 'КПГ',
        Electric: 'Електрична енергија',
      },

      fields: {
        date: 'Датум',
        odometerReading: 'Стање километраже',
        fuelType: 'Тип горива',
        liters: 'Литара',
        pricePerLiter: 'Цена по литри (KM)',
        totalCost: 'Укупан трошак (KM)',
        fuelStationName: 'Бензинска станица',
        fuelCardNumber: 'Број картице',
        invoiceNumber: 'Број рачуна',
        notes: 'Напомене',
      },
      validation: {
        odometerInvalid: 'Унесите валидну вредност',
        odometerMinimumValue: 'Километража не може бити 0',
        odometerMinimum: 'Километража мора бити већа или једнака {{min}} km',
        odometerMaximum: 'Километража не може бити већа од {{max}} km',
      },
      warnings: {
        odometerBelowCurrent: 'Упозорење: Унета километража ({{entered}} km) је мања од тренутне километраже возила ({{current}} km). Ово може бити у реду ако уносите историјске податке.',
      },
      helpers: {
        odometerRange: 'Минимално: {{min}} km',
        odometerRangeWithMax: 'Минимално: {{min}} km, Максимално: {{max}} km',
        pricePerLiter: 'Опционо - ако унесете, укупан трошак ће бити аутоматски израчунат',
        totalCost: 'Обавезно - унесите укупан трошак или цену по литри',
      },
    },
    fleetUsers: {
      title: 'Корисници возног парка',
      list: {
        title: 'Корисници',
        subtitle: 'Преглед корисника возног парка',
      },
      detail: {
        title: 'Детаљи корисника',
      },
      create: {
        title: 'Нови корисник',
        subtitle: 'Додај новог корисника возног парка',
      },
      edit: {
        title: 'Измени корисника',
        subtitle: 'Измени податке корисника',
      },
      fields: {
        firstName: 'Име',
        lastName: 'Презиме',
        email: 'Email',
        driverLicenseNumber: 'Број возачке дозволе',
        driverLicenseCategories: 'Категорије',
        driverLicenseCategoriesHelper: 'Унесите категорије одвојене зарезом (нпр. B, C, D)',
        driverLicenseExpiryDate: 'Датум истека',
        phoneNumber: 'Телефон',
      },
      tabs: {
        basicInfo: 'Основни подаци',
        driverInfo: 'Возачка дозвола',
        requests: 'Захтеви',
        travelOrders: 'Вожње',
      },
      sections: {
        basicInfo: 'Основни подаци',
        driverLicense: 'Возачка дозвола',
        contactInfo: 'Контакт информације',
      },
      noRequests: 'Нема захтева',
      noTravelOrders: 'Нема вожњи',
      createSuccess: 'Корисник успешно креиран',
      updateSuccess: 'Корисник успешно ажуриран',
      licenseExpiringSoon: 'Возачка дозвола истиче ускоро',
      licenseExpired: 'Возачка дозвола је истекла',
    },
  },
  users: {
    nav: {
      users: 'Корисници',
      roles: 'Улоге',
      permissions: 'Пермисије',
    },
    list: {
      title: 'Корисници',
      subtitle: 'Управљање корисницима система',
    },
    roles: {
      title: 'Улоге',
      subtitle: 'Управљање улогама и додела корисницима',
    },
    permissions: {
      title: 'Пермисије',
      subtitle: 'Управљање пермисијама корисника и улога',
    },
  },
  assignments: {
    warnings: {
      vehicleAlreadyAssigned: 'Упозорење: Возило је тренутно додељено кориснику {{userName}}. Нова додела ће аутоматски завршити тренутну доделу.',
      vehicleNotFree: 'Возило не може бити додељено јер тренутни статус није Слободно или У употреби. Тренутни статус: {{status}}',
    },
  },
  account: {
    title: 'Мој налог',
    subtitle: 'Управљање налогом и лозинком',
    profile: 'Профил',
    userInformation: 'Информације о кориснику',
    firstName: 'Име',
    lastName: 'Презиме',
    email: 'Емаил',
    changePassword: 'Промени лозинку',
    passwordSection: 'Промена лозинке',
    currentPassword: 'Тренутна лозинка',
    newPassword: 'Нова лозинка',
    confirmPassword: 'Потврди лозинку',
    passwordChanged: 'Лозинка је успешно промењена',
    passwordChangeFailed: 'Грешка при промени лозинке',
    invalidCurrentPassword: 'Тренутна лозинка није исправна',
    passwordsDoNotMatch: 'Лозинке се не поклапају',
    passwordTooShort: 'Лозинка мора имати најмање 8 карактера',
    changePasswordButton: 'Промени лозинку',
    changingPassword: 'Промена лозинке...',
  },
  apiErrors: {
    // Contract errors
    'Contract.ContractAmountExceeded': 'Износ прелази расположива средства уговора.',
    'Contract.ContractTerminated': 'Уговор је раскинут и не може се више користити.',
    // Travel Order Period errors
    'TravelOrderPeriod.NotFoundForMonth':
      'Путни налог за возило {{vehiclePlate}} у периоду {{period}} није креиран. Молимо креирајте путни налог пре одобравања захтјева.',
    'TravelOrderPeriod.NotFound': 'Путни налог није пронађен.',
    'TravelOrderPeriod.InvalidVehicleId': 'ID возила је обавезан.',
    'TravelOrderPeriod.InvalidResponsibleEmployeeId': 'ID одговорног запосленог је обавезан.',
    'TravelOrderPeriod.InvalidMonth': 'Мјесец мора бити између 1 и 12.',
    'TravelOrderPeriod.TravelOrderNumberRequired': 'Број путног налога је обавезан.',
    'TravelOrderPeriod.PeriodAlreadyExists': 'Период путног налога већ постоји за ово возило и мјесец.',
    'TravelOrderPeriod.PeriodNotOpen': 'Период путног налога није отворен за додавање нових вожњи.',
    'TravelOrderPeriod.OverlappingPeriod': 'Период се преклапа са постојећим периодом за ово возило.',
    'TravelOrderPeriod.VehicleAlreadyHasOpenPeriod': 'Није могуће креирати нови период јер возило већ има отворен период. Затворите постојећи период прво.',
    'TravelOrderPeriod.PeriodVehicleMismatch': 'Одабрани период не припада овом возилу.',
    'TravelOrderPeriod.HasActiveTrips': 'Није могуће затворити период док постоје активне вожње.',
    'TravelOrderPeriod.HasNonClosedTrips': 'Није могуће затворити период док постоје незатворене вожње. Све вожње морају бити затворене или отказане.',
    'TravelOrderPeriod.CannotCloseInCurrentStatus': 'Период може бити затворен само када је отворен.',
    'TravelOrderPeriod.CannotCancelInCurrentStatus': 'Период може бити отказан само када је отворен.',
    'TravelOrderPeriod.CancellationReasonRequired': 'Разлог отказивања је обавезан.',
    'TravelOrderPeriod.CannotModifyClosedPeriod': 'Није могуће изменити затворени или отказани период.',
    'TravelOrderPeriod.RequestCrossesMonthBoundary': 'Датуми захтјева морају бити унутар једног календарског мјесеца.',
    'TravelOrderPeriod.RequestOutsidePeriod': 'Датуми захтјева су изван граница периода.',
    'TravelOrderPeriod.EndDateMustBeAfterStartDate': 'Датум завршетка мора бити након датума почетка.',
    'TravelOrderPeriod.CannotSetEndDateOnNonOpenEndedPeriod': 'Није могуће поставити датум завршетка на период који није отвореног типа.',
    'TravelOrderPeriod.StartDateRequired': 'Датум почетка је обавезан за отворене периоде.',
    'TravelOrderPeriod.InvalidOdometer': 'Стање километраже мора бити позитивна вриједност.',
    'TravelOrderPeriod.EndOdometerLessThanStart': 'Завршна километража не може бити мања од почетне.',
    'TravelOrderPeriod.OdometerCannotDecrease': 'Километража не може бити мања од тренутне вриједности.',
    'TravelOrderPeriod.StartOdometerGreaterThanEnd': 'Почетна километража не може бити већа од завршне.',
    'TravelOrderPeriod.CannotModifyDatesOnMonthlyPeriod': 'Није могуће изменити датуме на мјесечном периоду.',
    'TravelOrderPeriod.OdometerLessThanLastTrip': 'Завршна километража не може бити мања од километраже посљедње вожње.',
    'TravelOrderPeriod.CannotReopenInCurrentStatus': 'Само затворени периоди могу бити поново отворени.',
    'TravelOrderPeriod.CannotReopenOverlappingPeriod': 'Није могуће поново отворити период јер постоји други активни период за исти временски распон.',
    'TravelOrderPeriod.CannotModifyCancelledPeriod': 'Није могуће изменити отказани период.',
    'TravelOrderPeriod.CannotCloseBeforeMonthEnds': 'Није могуће затворити период прије истека мјесеца.',
    'TravelOrderPeriod.CannotCorrectOdometerInCurrentStatus': 'Километража периода може бити коригована само на затвореним периодима.',
    'TravelOrderPeriod.EndOdometerLessThanLastTripEnd': 'Завршна километража периода ({{providedEnd}}) не може бити мања од највеће завршне километраже вожње у периоду ({{maxTripEnd}}).',
    'TravelOrderPeriod.StartOdometerExceedsFirstTripStart': 'Почетна километража периода ({{providedStart}}) не може бити већа од најмање почетне километраже вожње у периоду ({{minTripStart}}).',
    'TravelOrderPeriod.AtLeastOneOdometerRequired': 'Морате унијети барем једну вриједност: почетну или завршну километражу.',
    'TravelOrderPeriod.HasOpenOrCompletedTrips': 'Није могуће затворити период јер постоје отворене или завршене вожње. Све вожње морају бити затворене, отказане или у току (прекограничне).',
    'TravelOrderPeriod.InProgressTripWithoutNextSegment': 'Није могуће затворити период јер вожња у току нема сегмент у сљедећем периоду. Вожња мора бити завршена или отказана.',

    // Vehicle Request errors
    'VehicleRequest.NotFound': 'Захтјев за возило није пронађен.',
    'VehicleRequest.InvalidVehicleId': 'ID возила је обавезан.',
    'VehicleRequest.InvalidRequesterId': 'ID подносиоца захтјева је обавезан.',
    'VehicleRequest.PurposeRequired': 'Сврха је обавезна за захтјев за возило.',
    'VehicleRequest.InvalidDateRange': 'Датум завршетка мора бити након датума почетка.',
    'VehicleRequest.StartDateInPast': 'Датум почетка не може бити у прошлости.',
    'VehicleRequest.VehicleNotAvailable': 'Возило није доступно за тражени период.',
    'VehicleRequest.AlreadyApproved': 'Захтјев је већ одобрен.',
    'VehicleRequest.AlreadyRejected': 'Захтјев је већ одбијен.',
    'VehicleRequest.AlreadyCancelled': 'Захтјев је већ отказан.',
    'VehicleRequest.CannotApproveNonPending': 'Само захтјеви на чекању могу бити одобрени.',
    'VehicleRequest.CannotRejectNonPending': 'Само захтјеви на чекању могу бити одбијени.',
    'VehicleRequest.CannotCancelInCurrentStatus': 'Захтјев не може бити отказан у тренутном статусу.',
    'VehicleRequest.CannotCancelApprovedRequest': 'Одобрени захтјеви не могу бити отказани. Молимо откажите вожњу умјесто тога.',
    'VehicleRequest.CannotCancelActiveTripRequest':
      'Није могуће отказати захтјев јер је вожња већ у току или завршена.',
    'VehicleRequest.OverlappingRequest': 'Постоји преклапајући одобрен захтјев за ово возило.',
    'VehicleRequest.InvalidApproverId': 'Неважећи ID одобравача.',
    'VehicleRequest.RejectionReasonRequired': 'Разлог одбијања је обавезан.',
    'VehicleRequest.CannotLinkTravelOrderToNonApproved': 'Вожња може бити повезана само са одобреним захтјевима.',
    'VehicleRequest.CannotCompleteNonApproved': 'Само одобрени захтјеви могу бити означени као завршени.',
    'VehicleRequest.VehicleAssignedToAnotherDriver': 'Ово возило је додијељено другом возачу. Само додијељени возач или менаџери возног парка могу га захтијевати.',
    'VehicleRequest.VehicleReservationFailed': 'Грешка при резервацији возила током процеса одобравања.',
    'VehicleRequest.TravelOrderCreationFailed': 'Грешка при креирању вожње.',
    'VehicleRequest.VehicleNotAssigned': 'Возило мора бити додијељено прије него што захтјев може бити одобрен.',
    'VehicleRequest.CannotAssignVehicleToNonPending': 'Возило може бити додијељено само захтјевима на чекању.',
    'VehicleRequest.VehiclePlateNumberRequired': 'Регистарска ознака возила је обавезна при додјели возила.',
    'VehicleRequest.VehicleDescriptionRequired': 'Опис возила је обавезан при додјели возила.',

    // Travel Order errors
    'TravelOrder.NotFound': 'Вожња није пронађена.',
    'TravelOrder.NotFoundByOrderNumber': 'Вожња са наведеним бројем није пронађена.',
    'TravelOrder.RequestNotApproved': 'Вожња може бити креирана само из одобрених захтјева.',
    'TravelOrder.TravelOrderNumberRequired': 'Број вожње је обавезан.',
    'TravelOrder.VehicleAlreadyInUse': 'Возило је већ у употреби на другој вожњи.',
    'TravelOrder.CannotStartInCurrentStatus': 'Вожња не може бити покренута у тренутном статусу.',
    'TravelOrder.CannotEndInCurrentStatus': 'Вожња не може бити завршена у тренутном статусу.',
    'TravelOrder.EndOdometerLessThanStart': 'Завршна километража не може бити мања од почетне.',
    'TravelOrder.CannotCloseInCurrentStatus': 'Вожња може бити затворена само када је завршена.',
    'TravelOrder.CannotCancelInCurrentStatus': 'Вожња може бити отказана само када је отворена.',
    'TravelOrder.CannotAddFuelLogInCurrentStatus': 'Евиденција горива може бити додана само на вожње у току, завршене или затворене вожње.',
    'TravelOrder.CancellationReasonRequired': 'Разлог отказивања је обавезан.',
    'TravelOrder.InvalidVehicleId': 'ID возила је обавезан.',
    'TravelOrder.InvalidDriverId': 'ID возача је обавезан.',
    'TravelOrder.InvalidOdometer': 'Стање километраже мора бити позитивна вриједност.',
    'TravelOrder.VehicleNotAssigned': 'Није могуће креирати вожњу без додијељеног возила.',
    'TravelOrder.OdometerCannotDecrease': 'Километража не може бити мања од тренутне километраже возила.',
    'TravelOrder.OverlappingTravelOrder': 'Није могуће креирати вожњу јер већ постоји активна вожња за ово возило у траженом периоду.',
    'TravelOrder.CannotUpdateInCurrentStatus': 'Детаљи вожње могу бити ажурирани само када је отворена (није још покренута).',
    'TravelOrder.PeriodIdRequired': 'ID периода путног налога је обавезан.',
    'TravelOrder.InvalidTripNumber': 'Број вожње мора бити позитиван цијели број.',
    'TravelOrder.NotAuthorized': 'Немате дозволу за ову акцију на вожњи.',
    'TravelOrder.CannotCorrectOdometerInCurrentStatus': 'Километража може бити коригована само на завршеним или затвореним вожњама.',
    'TravelOrder.EndOdometerExceedsPeriodEnd': 'Завршна километража вожње ({{providedEnd}}) не може бити већа од завршне километраже затвореног периода ({{periodEnd}}).',
    'TravelOrder.StartOdometerLessThanPeriodStart': 'Почетна километража вожње ({{providedStart}}) не може бити мања од почетне километраже затвореног периода ({{periodStart}}).',

    // Vehicle errors
    'Vehicle.NotFound': 'Возило није пронађено.',
    'Vehicle.InvalidBrand': 'Марка возила је обавезна.',
    'Vehicle.InvalidModel': 'Модел возила је обавезан.',
    'Vehicle.InvalidPlateNumber': 'Регистарска ознака возила је обавезна.',
    'Vehicle.PlateNumberAlreadyExists': 'Возило са овом регистрацијом већ постоји.',
    'Vehicle.InvalidOdometerReading': 'Стање километраже мора бити позитивна вриједност.',
    'Vehicle.OdometerCannotDecrease': 'Километража не може бити мања од тренутне вриједности.',
    'Vehicle.InvalidPassengerSeats': 'Број путничких сједишта мора бити позитивна вриједност.',
    'Vehicle.InvalidRegistrationDates': 'Датум истека регистрације мора бити након датума регистрације.',
    'Vehicle.InvalidFleetUserId': 'ID корисника возног парка је обавезан за додјелу возача.',
    'Vehicle.InvalidFleetUserName': 'Име корисника возног парка је обавезно за додјелу возача.',
    'Vehicle.NoActiveAssignment': 'Није пронађена активна додјела возача за ово возило.',
    'Vehicle.NoResponsibleHolderAssigned': 'Возило нема додељеног носиоца. Доделите одговорну особу пре одобравања.',
    'Vehicle.InvalidExpectedEndDate': 'Очекивани датум завршетка мора бити у будућности за дугорочне додјеле.',
    'Vehicle.ExpectedEndDateRequiredForLongTerm': 'Очекивани датум завршетка је обавезан за дугорочне додјеле.',
    'Vehicle.InvalidAssignmentType': 'Неважећи тип додјеле. Мора бити Привремена, Дугорочна или Стална.',
    'Vehicle.AlreadyArchived': 'Возило је већ архивирано.',
    'Vehicle.CannotArchiveInUse': 'Возило не може бити архивирано док је у употреби.',
    'Vehicle.InvalidDescription': 'Опис је обавезан.',
    'Vehicle.InvalidCost': 'Трошак мора бити већи од нуле.',
    'Vehicle.NotFree': 'Возило није у валидном статусу за ову операцију.',
    'Vehicle.NotReserved': 'Возило не може бити означено као у употреби у тренутном статусу.',
    'Vehicle.Disposed': 'Возило је продано или расходовано и не може промијенити статус.',
    'Vehicle.NotAvailable': 'Возило није доступно за тражени период.',
    'Vehicle.AlreadyRegistered': 'Возило је већ регистровано. Користите обнову регистрације.',
    'Vehicle.NotRegistered': 'Возило није регистровано. Није могуће обновити регистрацију за нерегистровано возило.',
    'Vehicle.InvalidRegistrationNumber': 'Број саобраћајне је обавезан.',
    'Vehicle.OverlappingRegistration': 'Регистрација већ постоји за ово возило у наведеном периоду.',
    'Vehicle.CannotChangeDriverWithActiveTravelOrders': 'Није могуће промијенити додјелу возача док возило има активне вожње.',
    'Vehicle.CannotChangeDriverWithOpenTravelOrderPeriod': 'Није могуће промијенити додјелу возача док возило има отворен период путног налога. Затворите или откажите период прво.',
    'Vehicle.BlockNotFound': 'Блокада возила није пронађена.',
    'Vehicle.InvalidBlockReason': 'Разлог блокаде је обавезан.',
    'Vehicle.InvalidBlockDates': 'Датум завршетка блокаде мора бити након датума почетка.',
    'Vehicle.OverlappingBlock': 'Блокада већ постоји за ово возило у наведеном периоду.',
    'Vehicle.BlockAlreadyClosed': 'Ова блокада је већ затворена.',
    'Vehicle.CannotArchiveWithActiveBlocks': 'Возило не може бити архивирано док има активне блокаде.',
    'Vehicle.HasOverlappingTravelOrder': 'Возило има одобрену(активну) вожњу у траженом периоду.',
    'Vehicle.HasOverlappingBlock': 'Возило је блокирано у траженом периоду.',

    // Fleet User errors
    'FleetUser.NotFound': 'Корисник возног парка није пронађен.',

    // Generic fallback
    default: 'Дошло је до грешке. Покушајте поново.',
  },
  tireTracking: {
    nav: 'Евиденција гума',
    title: 'Гуме',
    addNew: 'Нова гума',
    searchPlaceholder: 'Претражи по марки, димензији, возилу...',
    statusFilterLabel: 'Статус',
    seasonFilterLabel: 'Сезона',
    allStatuses: 'Сви статуси',
    allSeasons: 'Све типове',
    totalCount: 'Укупно: {{count}} гума',
    errorLoading: 'Грешка при учитавању гума.',
    emptyMessage: 'Нема гума за приказ.',
    emptyMessageFiltered: 'Нема гума које одговарају филтерима.',
    status: {
      InStorage: 'На складишту',
      InUse: 'У употреби',
      Disposed: 'Отписана',
    },
    season: {
      Summer: 'Летња',
      Winter: 'Зимска',
      AllSeason: 'Све сезоне',
    },
    position: {
      FrontLeft: 'Предња лијева',
      FrontRight: 'Предња десна',
      RearLeft: 'Задња лијева',
      RearRight: 'Задња десна',
      RearLeftOuter: 'Задња лијева спољна',
      RearLeftInner: 'Задња лијева унутрашња',
      RearRightOuter: 'Задња десна спољна',
      RearRightInner: 'Задња десна унутрашња',
      Spare: 'Резервна',
    },
    columns: {
      brandModel: 'Марка / Модел',
      dimension: 'Димензија',
      type: 'Тип',
      status: 'Статус',
      vehicle: 'Возило',
      position: 'Позиција',
      dot: 'DOT',
      actions: 'Акције',
    },
    tooltips: {
      view: 'Прикажи детаље',
      edit: 'Измијени податке гуме',
      mount: 'Монтирај на возило',
      unmount: 'Скини с возила',
      editMileage: 'Измијени почетни km',
      dispose: 'Отпиши',
      reactivate: 'Врати у складиште',
      delete: 'Обриши',
    },
    fields: {
      brand: 'Марка',
      model: 'Модел',
      dimension: 'Димензија',
      dimensionHint: 'Димензија (нпр. 205/55 R16)',
      seasonType: 'Тип сезоне',
      dotCode: 'DOT код',
      purchaseDate: 'Датум куповине',
      notes: 'Напомена',
      position: 'Позиција',
      mountDate: 'Датум монтаже',
      unmountDate: 'Датум скидања',
      mileageAtInstall: 'Километража при монтажи',
      mileageAtInstallLabel: 'Километража при монтажи (km)',
      mileageAtRemoval: 'Километража при скидању',
      optional: 'Опционо',
      vehicle: 'Возило',
      tireFromStorage: 'Гума из складишта',
      noTiresInStorage: 'Нема гума у складишту',
    },
    validation: {
      brandRequired: 'Марка је обавезна',
      dimensionRequired: 'Димензија је обавезна',
      mountDateRequired: 'Датум монтаже је обавезан',
      unmountDateRequired: 'Датум скидања је обавезан',
      mileagePositive: 'Километража мора бити позитивна',
      tireRequired: 'Одабир гуме је обавезан',
    },
    create: {
      title: 'Нова гума',
      submit: 'Креирај',
      submitting: 'Креирање...',
      error: 'Грешка приликом креирања гуме',
      cancel: 'Откажи',
    },
    edit: {
      title: 'Измјена гуме',
      submit: 'Сачувај',
      submitting: 'Чување...',
      error: 'Грешка приликом измјене гуме',
      cancel: 'Откажи',
    },
    detail: {
      title: 'Детаљи гуме',
      brand: 'Марка',
      model: 'Модел',
      dimension: 'Димензија',
      seasonType: 'Тип сезоне',
      dotCode: 'DOT код',
      purchaseDate: 'Датум набавке',
      status: 'Статус',
      vehicle: 'Возило',
      position: 'Позиција',
      notes: 'Напомена',
      assignmentHistory: 'Историја монтаже',
      neverMounted: 'Гума није била монтирана.',
      active: 'Активна',
      table: {
        vehicle: 'Возило',
        position: 'Позиција',
        installed: 'Монтирано',
        removed: 'Скинуто',
        mileageAtInstall: 'km при монтажи',
        mileageAtRemoval: 'km при скидању',
      },
    },
    unmount: {
      title: 'Скини гуму с возила',
      submit: 'Скини гуму',
      submitting: 'Скидање...',
      error: 'Грешка приликом скидања гуме',
      cancel: 'Откажи',
    },
    dispose: {
      title: 'Отпиши гуму',
      confirm: 'Да ли сте сигурни да желите да отпишете гуму {{tire}}? Гума ће бити означена као отписана. Историја монтаже остаје сачувана.',
      submit: 'Отпиши',
      submitting: 'Отписивање...',
      error: 'Грешка приликом отписа гуме',
      cancel: 'Откажи',
    },
    reactivate: {
      title: 'Врати гуму у складиште',
      confirm: 'Да ли сте сигурни да желите да вратите гуму {{tire}} у складиште? Статус гуме ће бити промијењен из "Отписана" у "На складишту".',
      submit: 'Врати у складиште',
      submitting: 'Враћање...',
      error: 'Грешка приликом реактивације гуме',
      cancel: 'Откажи',
    },
    editMileage: {
      title: 'Измијени почетну километражу',
      tireInfo: 'Гума: {{info}}',
      submit: 'Сачувај',
      submitting: 'Чување...',
      error: 'Грешка приликом измјене километраже',
      cancel: 'Откажи',
    },
    mount: {
      title: 'Монтирај гуму',
      submit: 'Монтирај',
      submitting: 'Монтажа...',
      error: 'Грешка приликом монтаже гуме',
      cancel: 'Откажи',
    },
    mountToVehicle: {
      title: 'Монтирај гуму на возило',
      vehicleLabel: 'Возило:',
      submit: 'Монтирај',
      submitting: 'Монтажа...',
      error: 'Грешка приликом монтаже гуме',
      cancel: 'Откажи',
    },
    registerAndMount: {
      title: 'Додај нову гуму на возило',
      vehicleLabel: 'Возило:',
      tireInfoSection: 'Подаци о гуми',
      mountSection: 'Монтажа',
      submit: 'Додај и монтирај',
      submitting: 'Додавање...',
      error: 'Грешка приликом додавања гуме',
      cancel: 'Откажи',
    },
  },
  footer: {
    allRightsReserved: 'Сва права задржана.',
    support: 'Подршка',
    privacyPolicy: 'Политика приватности',
    termsOfUse: 'Услови коришћења',
  },
} as const;
